module.exports = __webpack_public_path__ + "img/mod.ee4428f9.svg";